import restUtils from "core/utils/rest";
import { Adviser, AdviserPage } from "../model";


const UMAPI = "UserManagementApi";
const ADVISER = "adviser";

class AdviserStore {

  getAdvisers = async (payload: any) => {
    return await restUtils.call<AdviserPage>(UMAPI, ADVISER, "GET", payload);
  };

  getAdviser = async (id: any) => {
    return await restUtils.call<Adviser>(UMAPI, ADVISER + `/${id}`, "GET");
  };

  createAdviser = async (payload: any) => {
    return await restUtils.call<any>(UMAPI, ADVISER, "POST", payload);
  };

  updateAdviser = async (id: any, payload: any) => {
    return await restUtils.call<any>(UMAPI, ADVISER + `?id=${id}`, "PUT", payload);
  };
  disableMFAAdviser = async (payload: any) => {
    return await restUtils.call<any>(UMAPI, ADVISER + "/modify-mfa", "PATCH", payload);
  };
  getRoles = async (customer_id: string) => {
    return await restUtils.call<any>(UMAPI, ADVISER + "/roles/" +`${customer_id}`, "GET");
  };
}

const adviserStore = new AdviserStore();
export default adviserStore;
